export const LANGUAGES = '/api/medics/languages';
